// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-lable {
  text-align: center !important;
  color: black !important;
}`, "",{"version":3,"sources":["webpack://./src/app/model/appsharepopup/appsharepopup.component.scss"],"names":[],"mappings":"AAAA;EACI,6BAAA;EACA,uBAAA;AACJ","sourcesContent":["ion-lable {\n    text-align: center !important;\n    color: black !important;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
